// extracted by mini-css-extract-plugin
module.exports = {"back-container":"BackButton_back-container__O0uze","back-arrow":"BackButton_back-arrow__TDuzZ","clicked":"BackButton_clicked__vH1Br"};